module.exports = __webpack_public_path__ + "static/img/dd-partner-04.454bc2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-partner-04.jpg
// module id = XC+6
// module chunks = 1